import type { ReactElement } from "react";

import type { LinkProps } from "react-router";

import { styled } from "simplydo/react/styled";

import { RenderCard } from "./Card";
import type { CardProps } from "./Card.types";

export type CardLinkProps = CardProps &
  Omit<LinkProps, "color" | "children" | "className">;

const CardLinkComponent = (props: CardLinkProps): ReactElement => (
  <RenderCard {...props} asLink />
);

export const CardLink = styled(CardLinkComponent)``;
